import af from './afg_flag.png';
//import al from './custom-flags/al.png';
// Add more imports for each country...

export default {
  AF: af,
  //AL: al,
  // Add more entries for each country...
};
